import { createContext, useContext } from "react";
import { useAdminDashboardState } from "./useAdminDashboard";

const AdminDashboardContext = createContext(null);

export const AdminDashboardProvider = ({ children }) => {
  const value = useAdminDashboardState();
  return (
    <AdminDashboardContext.Provider value={value}>
      {children}
    </AdminDashboardContext.Provider>
  );
};

export const useAdminDashboardCtx = () => {
  const ctx = useContext(AdminDashboardContext);
  if (!ctx) {
    throw new Error("useAdminDashboardCtx must be used within AdminDashboardProvider");
  }
  return ctx;
};
